import Immutable from 'immutable';

export default function ContainerDefinition(items) {
	if (!(this instanceof ContainerDefinition)) {
		return new ContainerDefinition(items);
	}


	let visibleCallback;
	let visible = true;

	if (items) {
		items.forEach(item => {
			item._parentDefinition = this;
		});

		items = Immutable.List(items);
	}

	this.getItems = function() {
		return items;
	};

	this.setVisible = function(value) {
		if (typeof value === 'function') {
			visibleCallback = value;
			visible = true;
		} else {
			visibleCallback = null;
			visible = value;
		}
		return this;
	};

	const isVisible = function(ctx) {
		if (visibleCallback) {
			return visibleCallback(ctx);
		} else {
			return visible;
		}
	};


	this.validateAll = function(ctx, errors) {
		items.forEach(item => {
			item.validateAll(ctx, errors);
		})
	}

	this.validateOnChange = function(ctx, errors, itemName) {
		if (this._parentDefinition && this._parentDefinition.validateOnChange) {
			this._parentDefinition.validateOnChange(ctx, errors, itemName);
		}
	};


	this.render = function(ctx, key = 0) {
		if (!isVisible(ctx)) {
			return null;
		}
		const keySfx = key + '_';
		return items.map((item, index) => item.render(ctx, keySfx + index));
	};
}
